<template>
  <div id="app_content" :class="privacyClass +  ' privacy'">

    <div class="app-pp">

      <a href="https://www.iubenda.com/privacy-policy/20292138" class="iubenda-black no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Privacy Policy">Privacy Policy</a>


    </div>

  </div>
</template>

<script>
export default {
  data: function () {
    return {
      privacyClass: null,
    };
  },

  computed: {},
mounted() {
this.whereami()
    },
  methods: {
    whereami: function () {
      let path = window.location.pathname
      switch (path){
        case '/privacy-policy':
          this.privacyClass = 'public'
              break
        case '/b2b/privacy-policy':
          this.privacyClass = 'reserved'
      }
    }
  },
};

  (function (w,d) {var loader = function () {
  var s = d.createElement("script"),
  tag = d.getElementsByTagName("script")[0];
  s.src="https://cdn.iubenda.com/iubenda.js";
  tag.parentNode.insertBefore(s,tag);
};
  if(w.addEventListener){
  w.addEventListener("load", loader, false);
}
  else if(w.attachEvent){
  w.attachEvent("onload", loader);
}
  else{
  w.onload = loader;
}
})(window, document);

</script>

<style lang="scss" scoped>

</style>
